import { StrictMode } from 'react'

import { RouterProvider } from 'react-router-dom'

import { Routing } from './lib/routing'

const App = () => {
  return (
    <StrictMode>
      <RouterProvider router={Routing} />
    </StrictMode>
  )
}

export default App
